jQuery(document).ready(function($) { 

   var CpegHeader = document.querySelector("header.site-header");
   function isNavVisible(CpegHeader) {
    return (CpegHeader.classList.contains('open-s-menu') ? true : false );
   }
   var options = {
    offset : 60,
      tolerance : {
          up : 5,
          down : 0
      },
    onUnpin: function() {
      if ( isNavVisible(CpegHeader) ) {
        this.elem.classList.remove(this.classes.unpinned);
        this.elem.classList.add(this.classes.pinned);
      }
      else {
        this.elem.classList.add(this.classes.unpinned);
        this.elem.classList.remove(this.classes.pinned);
      }
    }
  };

  var headroom  = new Headroom(CpegHeader,options);


  // initialise
  headroom.init();


      /* Accessibility / Light / Dark and Contraste thème */
 
    function calculateSettingAsThemeString({ localStorageTheme}) {

      if (localStorageTheme !== null) {
        return localStorageTheme;
      }

      return "standard";
    }


    /**
    * Utility function to update the theme setting on the html tag
    */
    function updateThemeOnHtmlEl({ theme }) {
      document.querySelector("html").setAttribute("data-theme", theme);
        buttonsChangeTheme.forEach(item => {
        item.classList.remove("selected");
      });
        document.querySelector('[data-theme-toggle][data-theme="'+theme+'"]').classList.add("selected");
    }

    /**
    * On page load:
    */


    /**
    * 1. Grab what we need from the DOM and system settings on page load
    */
    const buttonsChangeTheme = document.querySelectorAll("[data-theme-toggle]");
    const localStorageTheme = localStorage.getItem("theme");

    /**
    * 2. Work out the current site settings
    */
    let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme });

    /**
    * 3. Update the theme setting and button text accoridng to current settings
    */
    updateThemeOnHtmlEl({ theme: currentThemeSetting });


    /**
    * 4. Add an event listener to toggle the theme
    */
    buttonsChangeTheme.forEach(item => {
      item.addEventListener('click', event => {
        //handle click
        const newTheme = item.dataset.theme;
        localStorage.setItem("theme", newTheme);
        updateThemeOnHtmlEl({ theme: newTheme });
        currentThemeSetting = newTheme;
    
      });
    });


    /*****************************************************/
      /************** CHANGE SIZE TYPOGRAPHIE ****/
    /*****************************************************/

    function calculateSettingSize({ localStorageSize}) {
        if (localStorageSize !== null) {
          return localStorageSize;
        }
        return "100";
    }


     function updateSizeOnHtmlEl({ size }) {
       // document.querySelector("html").setAttribute("data-size", size+'%');
       document.querySelector("html").style.fontSize = size+'%';


       if(parseInt(size) > 125){
        document.querySelector('[data-size="more"]').disabled = true;
       }else{
          document.querySelector('[data-size="more"]').disabled = false;
       }

       if(parseInt(size) < 75){
        document.querySelector('[data-size="less"]').disabled = true;
       }else{
          document.querySelector('[data-size="less"]').disabled = false;
       }

        if(parseInt(size) == 100){
        document.querySelector('[data-size="standard"]').disabled = true;
       }else{
          document.querySelector('[data-size="standard"]').disabled = false;
       }



        //   buttonsChangeTheme.forEach(item => {
        //     item.classList.remove("selected");
        // });
        //   document.querySelector('[data-theme-toggle][data-theme="'+theme+'"]').classList.add("selected");
     }

    const buttonsChangeSize = document.querySelectorAll("[data-change-size]");
    const localStorageSize = localStorage.getItem("size");

    let currentThemeSize = calculateSettingSize({ localStorageSize});
    updateSizeOnHtmlEl({size:currentThemeSize});

    buttonsChangeSize.forEach(item => {
        item.addEventListener('click', event => {
          //handle click
          const SizeDirection = item.dataset.size;
          if(SizeDirection == 'standard') newSize = 100; 
          else if(SizeDirection == 'less') newSize = parseInt(currentThemeSize)-10; else newSize = parseInt(currentThemeSize)+10;
          localStorage.setItem("size", newSize);
          updateSizeOnHtmlEl({ size: newSize });
          updatePaddingContainerSM();
          currentThemeSize = newSize;
        });
    });


  function updatePaddingContainerSM() {
    const mainNavMenu = document.querySelector('.main-nav-menu');
    const headerSubContainers = document.querySelectorAll('.header-sub-container');

     if (window.innerWidth <= 1024) {
        // On remet le padding à 0 si on repasse sous 1024px
        headerSubContainers.forEach(container => {
            container.style.paddingLeft = '';
        });
        return;
    }
    
    if (mainNavMenu && headerSubContainers.length > 0) {
        // Largeur de main-nav-menu en pixels
        const mainNavWidth = mainNavMenu.offsetWidth;

        headerSubContainers.forEach(container => {
            // Largeur du conteneur actuel
            const containerWidth = container.offsetWidth;

            // Calculer le padding-left en pourcentage par rapport à la largeur du conteneur
            const paddingLeftPercent = ((containerWidth - mainNavWidth) / containerWidth) * 100;

            // Appliquer le padding-left
            container.style.paddingLeft = paddingLeftPercent + '%';
        });
    }
}

// Mise à jour au chargement
window.addEventListener('load', updatePaddingContainerSM);

// Mise à jour au redimensionnement
window.addEventListener('resize', updatePaddingContainerSM);
  


  /************************************************************/
  /*************** SEARCH BTN / CONTAINER *************************/
  /************************************************************/

    const btnSearch = document.querySelector('.btn-search');
    const overlay = document.querySelector('#search-overlay');
    const closeBtn = document.querySelector('.search-close');
    const site = document.querySelector('#primary'); // wrapper général du thème

    btnSearch.addEventListener('click', () => {
        const isOpen = overlay.classList.toggle('is-open');

        btnSearch.setAttribute('aria-expanded', isOpen);
        overlay.setAttribute('aria-hidden', !isOpen);

        // Activation du flou du site
        if (isOpen) {
            site.classList.add('blur-active');
            setTimeout(() => overlay.querySelector('input[type="search"]').focus(), 300);
        } else {
            site.classList.remove('blur-active');
            btnSearch.focus();
        }
    });

    closeBtn.addEventListener('click', () => {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', true);
        btnSearch.setAttribute('aria-expanded', false);
        site.classList.remove('blur-active');
        btnSearch.focus();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === "Escape") {
            overlay.classList.remove('is-open');
            overlay.setAttribute('aria-hidden', true);
            btnSearch.setAttribute('aria-expanded', false);
            site.classList.remove('blur-active');
        }
    });





  /****************************************************************************/
  /***************** INFINITE SCROLL *********************/
  /****************************************************************************/

      // init Infinite Scroll
    
     //  $('.HeadIndexPost-Filter select').niceSelect();
        $('.search-post-reload select').on('change', function() {
          document.location=this.value;
      });


     if($('.paginate-post').length){
    
      $('.Allpost-Container').infiniteScroll({
          path: '.pagination__next',
          append: '.item-infinite',
          status: '.page-load-status',
          hideNav: '.pagination__next',
      });
   

    // $('.Allpost-Container').on( 'request.infiniteScroll', function( event, path, fetchPromise ) {
    //   console.log(`Loading page: ${path}`);
    // });

     $('.Allpost-Container').on( 'append.infiniteScroll', function( event, body, path, items, response ) {
      $(items).addClass('anim-to-appear');
    });

      }

     /// Search infinite scroll 

      if($('.paginate-search').length){
    
      $('.container_search_item').infiniteScroll({
          path: '.pagination__next',
          append: '.item-infinite',
          status: '.page-load-status',
          hideNav: '.pagination__next',
          history: false,
      });

        $('.container_search_item').on( 'append.infiniteScroll', function( event, body, path, items, response ) {
        $(items).addClass('anim-to-appear');
      });
    }

    // $('.container_search_item').on( 'request.infiniteScroll', function( event, path, fetchPromise ) {
    //   console.log(`Loading page: ${path}`);
    // });

     
    $('select.form-control').addClass('wide');
    $('select.form-control').niceSelect();




    /*****************************************************/
      /************** BTN OPEN / CLOSE SUB MENU ****/
    /*****************************************************/

   var $prev_menu_open = '';
   var $prev_dest_menu_open = '';
   function active_sub_menu($active_menu,$dest_sub_menu){

    if($prev_menu_open != '' && ($prev_menu_open != $active_menu)){
         disable_sub_menu($prev_menu_open, $prev_dest_menu_open);
    }

    $('.site-header').addClass('open-s-menu');
    $('.container_menu .main-nav-menu-item.toDoHover').removeClass('is-hover');
    $('.header-sub').removeClass('active');
    if($active_menu){
         $active_menu.addClass('is-hover');
         $active_menu.find('.nav__main_btn').attr('aria-expanded', true);
    } 
   
    $dest_sub_menu.addClass('active');
    // Remove previous hover actions
    // $dest_sub_menu.find('.is-hover').removeClass('is-hover');
    // $('.AppearRight.to_visible').removeClass('to_visible');
  }

  function disable_sub_menu($active_menu,$dest_sub_menu){
     if($active_menu){
      $active_menu.removeClass('is-hover');
       $active_menu.find('.nav__main_btn').attr('aria-expanded', false);
     }
    $dest_sub_menu.removeClass('active');
    $('.site-header').removeClass('open-s-menu');
   // header.removeClass('bg_for_hover');
  }

    $( ".container_menu .main-nav-menu-item.toDoHover button" ).click(function(e) {

        $active_menu = $(this).parent();
        

        if($(this).attr('aria-expanded') == 'false'){
            // On ouvre ce menu
            $dest_sub_menu = $('.header-sub[data-link-id="'+$(this).attr('data-link-id')+'"]'); 
             active_sub_menu($active_menu, $dest_sub_menu);
            
             $prev_menu_open = $active_menu;
             $prev_dest_menu_open = $('.header-sub[data-link-id="'+$(this).attr('data-link-id')+'"]');
            
        }else{
            // On ferme ce menu 
             disable_sub_menu($active_menu, $dest_sub_menu);
        }
       
       
        e.preventDefault();
    });

    /* Close Btn Desktop Only */
    $( ".container_menu .close-desktop-menu" ).click(function(e) {
      if($prev_menu_open != '') disable_sub_menu($prev_menu_open,$prev_dest_menu_open);    
    });


    
    // Click sur retour dans sous-menu pour mobile // 
     $( "button.header-sub-titleContainer" ).click(function(e) {
        if($(this).attr('data-level') == 'sub-sub'){
           disable_sub_sub_menu_mobile($active_menu, $dest_sub_menu);
        }else{
           disable_sub_menu($active_menu, $dest_sub_menu);
        }
    });

   

    $('.menu-toggle').click(function(e){
        if($(this).attr('aria-expanded') == 'false'){
            // On desable les sub-menu et les sub-sub-menu avant de fermer
             disable_sub_menu($active_menu, $dest_sub_menu);
         }
    });


    (function () {
  const panel = document.getElementById("quick-access-panel");
  if (!panel) return;

  const btn = document.getElementById("quick-access-btn");
  const closeBtn = panel.querySelector(".close-btn");
  const content = panel.querySelector(".panel-content");

  if (!btn || !closeBtn || !content) return;

  const focusableSelectors =
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  let lastFocusedEl = null;

  // ✅ État initial a11y (important si ton HTML ne le met pas déjà)
  btn.setAttribute("aria-controls", content.id || "quick-access-content");
  if (!content.id) content.id = "quick-access-content";
  btn.setAttribute("aria-expanded", "false");

  // On cache UNIQUEMENT le contenu (pas le panel entier, sinon warning Chrome)
  content.setAttribute("aria-hidden", "true");

  function openPanel() {
    lastFocusedEl = document.activeElement;

    panel.classList.add("is-animating");
    panel.classList.add("open");

    btn.setAttribute("aria-expanded", "true");
    content.setAttribute("aria-hidden", "false");

    // Fin animation
    setTimeout(() => {
      panel.classList.remove("is-animating");
    }, 450);

    closeBtn.focus();
  }

  function closePanel() {
    panel.classList.remove("open");

    btn.setAttribute("aria-expanded", "false");
    content.setAttribute("aria-hidden", "true");

    // Rendre le focus au bouton (ou à l’élément précédent si tu préfères)
    if (lastFocusedEl && document.contains(lastFocusedEl)) {
        lastFocusedEl.focus();
      } else {
        btn.focus();
      }
  }

  // Toggle (pratique si on reclique sur le bouton)
  function togglePanel() {
    if (panel.classList.contains("open")) closePanel();
    else openPanel();
  }

  btn.addEventListener("click", togglePanel);
  closeBtn.addEventListener("click", closePanel);

  /* 1) Clic en dehors = fermer (mobile only, et pas pendant l’anim) */
  document.addEventListener("click", (e) => {
    if (window.innerWidth > 768) return; // mobile only
    if (!panel.classList.contains("open")) return;
    if (panel.classList.contains("is-animating")) return;
    if (content.contains(e.target) || btn.contains(e.target)) return; // clic dans le panel ou sur le bouton
    closePanel();
  });

  /* 2) Escape */
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && panel.classList.contains("open")) {
      e.preventDefault();
      closePanel();
    }
  });

  /* 3) Focus Trap (quand ouvert) */
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Tab" || !panel.classList.contains("open")) return;

    const focusables = [...content.querySelectorAll(focusableSelectors)]
      .filter(el => !el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true");

    // On inclut aussi le bouton fermer si jamais il est hors content (selon ton HTML)
    if (!focusables.includes(closeBtn)) focusables.unshift(closeBtn);

    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
    
    //
// COLOR MENU TITLE //
//

    let lastViewportWidth = window.innerWidth;

    function colorizeTitleLines() {
      const title = document.getElementById("dynamic-color-title");
      if (!title) return;

      const rawHtml = title.dataset.rawHtml || title.innerHTML.trim();
      title.dataset.rawHtml = rawHtml;

      let segments;

      if (window.innerWidth <= 768) {
        // Mobile / tablette → ignorer les <br> admin
        segments = [rawHtml.replace(/<br\s*\/?>/gi, " ")];
      } else {
        // Desktop → respecter les <br> admin
        segments = rawHtml
          .split(/<br\s*\/?>/gi)
          .map((s) => s.trim())
          .filter(Boolean);
      }

      title.innerHTML = "";

      const measurer = document.createElement("span");
      measurer.style.visibility = "hidden";
      measurer.style.position = "fixed";
      measurer.style.left = "-9999px";
      measurer.style.whiteSpace = "normal";
      measurer.style.display = "inline-block";
      measurer.style.width = getComputedStyle(title).width; // permet le wrapping réel
      title.appendChild(measurer);

      let allLines = [];

      segments.forEach((segment, segIndex) => {
        const words = segment
          .replace(/<[^>]*>/g, "")
          .split(/(\s+)/)
          .filter(Boolean);

        measurer.innerHTML = "";

        const spans = words.map((w) => {
          const s = document.createElement("span");
          s.textContent = w;
          measurer.appendChild(s);
          return s;
        });

        let currentTop = null;
        let currentLine = [];
        let lines = [];

        spans.forEach((span) => {
          const { top } = span.getBoundingClientRect();

          if (currentTop === null || Math.abs(top - currentTop) < 2) {
            currentLine.push(span);
            currentTop = top;
          } else {
            lines.push(currentLine);
            currentLine = [span];
            currentTop = top;
          }
        });

        if (currentLine.length) lines.push(currentLine);

        allLines.push(
          ...lines.map((line) => line.map((s) => s.textContent).join(""))
        );

        if (segIndex < segments.length - 1) {
          allLines.push("__FORCED_BR__");
        }
      });

      title.innerHTML = "";

      const visibleLines = allLines.filter((l) => l !== "__FORCED_BR__").length;
      let index = 0;
      let lineDisplayIndex = 0;

      allLines.forEach((line, i) => {
        if (line === "__FORCED_BR__") {
          title.appendChild(document.createElement("br"));
          return;
        }

        const span = document.createElement("span");

        // Gestion des couleurs
        if (visibleLines === 1) {
          span.classList.add("line-1");
        } else if (visibleLines === 2) {
          span.classList.add(index === 0 ? "line-1" : "line-2");
        } else {
          if (index === 0) span.classList.add("line-1");
          else if (index === visibleLines - 1) span.classList.add("line-3");
          else span.classList.add("line-middle");
        }

        // Animation
        span.classList.add("title-line");
        span.style.setProperty("--i", lineDisplayIndex++);

        span.textContent = line;
        title.appendChild(span);

        if (i < allLines.length - 1 && allLines[i + 1] !== "__FORCED_BR__") {
          title.appendChild(document.createElement("br"));
        }

        index++;
      });

      title.classList.add("ready");
    }

  /* Init */
  window.addEventListener("load", colorizeTitleLines);

  /* Resize : recalcul UNIQUEMENT si la largeur change */
  window.addEventListener("resize", () => {
    const currentWidth = window.innerWidth;

    // Ignore les resize dus à la hauteur (mobile scroll)
    if (currentWidth === lastViewportWidth) return;

    lastViewportWidth = currentWidth;

    clearTimeout(window._titleTimer);
    window._titleTimer = setTimeout(colorizeTitleLines, 150);
  });

      /***********************************************/   
      /******** SLIDER ONLY ON MOBILE // EMPLOYE / LIST************/
      /***********************************************/
        var swipersEmployees = []; 
        var employeesInitialized = false;

        function swiperCard() {
          const sliders = document.querySelectorAll(".slider-employees-js");

          // Si fenêtre < 600px → on initialise si pas déjà fait
          if (window.innerWidth < 600) {
            if (!employeesInitialized) {
              employeesInitialized = true;

              sliders.forEach((slider, index) => {
                swipersEmployees[index] = new Swiper(slider, {
                  slidesPerView: 1.8,
                  initialSlide: 2,
                  centeredSlides: true,
                  spaceBetween: 16,
                  breakpoints: {
                    620: { slidesPerView: 3.2 },
                    500: { slidesPerView: 2.8 },
                    400: { slidesPerView: 2.2 }
                  }
                });
              });
            }

          // Sinon → destroy tous les sliders si déjà init
          } else if (employeesInitialized) {
            swipersEmployees.forEach(swiper => swiper.destroy(true, true));
            swipersEmployees = [];
            employeesInitialized = false;
          }
        }

        swiperCard();
        window.addEventListener("resize", swiperCard);


        /***********************************************/   
          /******** SLIDER SIMPLE GALERY ONE COL ************/
      /***********************************************/
      $( ".SimpleGallery-one_col-container" ).each(function( index ) {
      
          let cursor_next = '#'+$(this).find('.swiper-button-next').attr('id');
          let cursor_prev =  '#'+$(this).find('.swiper-button-prev').attr('id');
          let swiper_id = $(this).find('.slider-sgallery-one_col-js').attr('id');
          var swiper_gallery_one_col = new Swiper('#'+swiper_id, {
                spaceBetween: 50, // try '5%' if you want
                slidesPerView: 1,
                loop:true,
                 breakpoints: {
                    768: { // a partir de 769
                      spaceBetween: 20,
                    }
                },

                pagination: {
                  el: '.swiper-bullet-pagination',
                  clickable: true
                },
                navigation: {
                   nextEl: cursor_next,
                   prevEl: cursor_prev
                },
                autoplay: {
                  delay: 6000,
                  disableOnInteraction: false
                },
        });

    });

     /***********************************************/   
        /******** SLIDER SIMPLE GALERY TWO COL ************/
    /***********************************************/

     $( ".SimpleGallery-two_col-container" ).each(function( index ) {
      
          let cursor_next = '#'+$(this).find('.swiper-button-next').attr('id');
          let cursor_prev =  '#'+$(this).find('.swiper-button-prev').attr('id');
          let swiper_id = $(this).find('.slider-sgallery-two_col-js').attr('id');
          var swiper_gallery_one_col = new Swiper('#'+swiper_id, {
                spaceBetween: 50, // try '5%' if you want
                slidesPerView: 1,
                loop:true,

                 breakpoints: {
                    500: { // a partir de 769
                      spaceBetween: 16,
                      slidesPerView: 2,
                    }
                },

                pagination: {
                  el: '.swiper-bullet-pagination',
                  clickable: true
                },
                navigation: {
                   nextEl: cursor_next,
                   prevEl: cursor_prev
                },
                autoplay: {
                  delay: 6000,
                  disableOnInteraction: false
                },
        });

    });





   ////////////////
    //// GLOBAL accordion 
   ///////////////
   $('.accordion-section-content').hide();
  
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////


      /***********************************************/   
        /******** SLIDER QF BIG ***********/
    /***********************************************/

    document.querySelectorAll('.mZa_slider_qf-inner').forEach((sliderEl) => {
      
        let slider = sliderEl.querySelector(".slider-Bigqf-js");
        const swiper = new Swiper(slider, {
          slidesPerView: 1,
              loop: true,
              autoplayDisableOnInteraction: false,
              effect: "fade",
              fadeEffect: { crossFade: true },
              speed: 1000, 
              autoplay: {
                delay: 6000,
                disableOnInteraction: false
              },
          on: {
            slideChangeTransitionStart() {
              const progress = sliderEl.querySelector('.progress');

              // Supprime l’animation
              progress.classList.remove('progress-animate');

              // Force le reflow pour réinitialiser l'animation
              void progress.offsetWidth;

              // Relance l’animation
              progress.classList.add('progress-animate');
            },

            init() {
              // Lancer l'animation au chargement
              const progress = sliderEl.querySelector('.progress');
              progress.classList.add('progress-animate');
            }
          }
        });

      });



      /***********************************************/   
        /******** CHIFFRES CLES ***********/
    /***********************************************/

       const resetNumber = (slide) => {
          const el = slide.querySelector('.number');
          if (!el) return;

          // Reset flag
          el.dataset.animated = "false";

          // Remove animation CSS
          el.classList.remove("visible");

          // Reset to zero (formaté ou non)
          el.textContent = "0";
      };

      const animateNumber = (slide) => {
          const el = slide.querySelector('.number');
          if (!el) return;

          // déjà animé ?
          if (el.dataset.animated === "true") return;

          el.dataset.animated = "true";

          // Animation CSS
          setTimeout(() => {
              el.classList.add("visible");
          }, 10);

          const target = parseFloat(el.dataset.number.replace(',', '.')); // support 22567,09 ou 22567.09
          const counter = new countUp.CountUp(el, target, {
              separator: "’",
              decimal: ".",
              decimalPlaces: (el.dataset.number.includes(',') || el.dataset.number.includes('.')) ? 2 : 0,
              duration: 1.2
          });

          counter.start();
      };


   

      document.querySelectorAll('.container-slider-keyfigure').forEach((sliderEl) => {

          let cursor_next = sliderEl.querySelector(".swiper-button-next");
          let cursor_prev =  sliderEl.querySelector(".swiper-button-prev");
          let swiper_elt = sliderEl.querySelector(".key-figure-js");
        

          const swiper = new Swiper(swiper_elt, {
              loop: true,
              speed: 900,
              allowTouchMove: false,
              slidesPerView: 1,
              watchSlidesProgress: true, // 🔥 obligatoire
              autoplay: {
                  delay: 6000,
                  disableOnInteraction: false
              },

              pagination: {
                el: '.swiper-bullet-pagination',
                clickable: true
              },
              navigation: {
                 nextEl: cursor_next,
                 prevEl: cursor_prev
              },

              breakpoints: {
                  1024: {
                      slidesPerView: 3,
                      spaceBetween: 65,
                      allowTouchMove: false,
                  },
                  768: {
                      slidesPerView: 2,
                      spaceBetween: 65,
                      allowTouchMove: false,
                  }
              },

              on: {
                  init() {
                      // 🔥 Animer les slides visibles au chargement
                      this.slides.forEach(slide => {
                          if (slide.classList.contains('swiper-slide-visible')) {
                              animateNumber(slide);
                          }
                      });
                  },

                  slideChangeTransitionEnd() {
                      // 🔄 RESET DES SLIDES INVISIBLES
                      this.slides.forEach(slide => {
                          if (!slide.classList.contains('swiper-slide-visible')) {
                              resetNumber(slide);
                          }
                      });

                      // 🔥 ANIMER LES NOUVEAUX SLIDES VISIBLES
                      this.slides.forEach(slide => {
                          if (slide.classList.contains('swiper-slide-visible')) {
                              animateNumber(slide);
                          }
                      });
                  }
              }
          });

      });

       /***********************************************/   
          /******** SWIPER PERSONNAGE ROW 1  ************/
      /***********************************************/

      document.querySelectorAll('.slider-character-row1-js').forEach((sliderCarac) => {

          const swiper = new Swiper(sliderCarac, {
               slidesPerView: 'auto',
                speed: 8000,
                spaceBetween:16,
                allowTouchMove: false,
                loop:true,
                autoplay: {delay: 0,pauseOnMouseEnter: false, disableOnInteraction: false},
                 // breakpoints: {
                 //   640: {
                 //     slidesPerView: 3,
                 //   },    
                 //   768: {
                 //     slidesPerView: 4,
                 //   },
                 //   1250: {
                 //     slidesPerView: 4,
                 //   },
                 //   1450: {
                 //     slidesPerView: 5.5,
                 //   }
                 // }
              });

      });


       document.querySelectorAll('.slider-character-row2-js').forEach((sliderCarac) => {

          const swiper = new Swiper(sliderCarac, {
               slidesPerView: 'auto',
                speed: 8000,
                spaceBetween:16,
                allowTouchMove: false,
                loop:true,
                autoplay: {reverseDirection:true,delay: 0,pauseOnMouseEnter: false, disableOnInteraction: false},
                 // breakpoints: {
                 //   640: {
                 //     slidesPerView: 3,
                 //   },    
                 //   768: {
                 //     slidesPerView: 4,
                 //   },
                 //   1250: {
                 //     slidesPerView: 4,
                 //   },
                 //   1450: {
                 //     slidesPerView: 5.5,
                 //   }
                 // }
              });

      });


 


       /***********************************************/   
          /******** SWIPER TIMELINE VERTICALE ************/
      /***********************************************/


       document.querySelectorAll('.container-slider-timeline').forEach((sliderEl) => {

          let cursor_next = sliderEl.querySelector(".swiper-button-next");
          let cursor_prev =  sliderEl.querySelector(".swiper-button-prev");
          let timeline_vertical_js = sliderEl.querySelector(".timeline-vertical-js");
          let pagination_verticale = sliderEl.querySelector(".swiper-bullet-pagination");
         

          const slides = sliderEl.querySelectorAll('.swiper-slide');
          const realSlides = Array.from(slides).filter(s => !s.classList.contains('is-blank'));

          const blankAtStart = 1; // nombre de blank au début

          const swiper = new Swiper(timeline_vertical_js, {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 0,
            //mousewheel: false,
            initialSlide: 1, // car slide-blank en premier
            speed: 600,


              breakpoints: {
                  768: { // a partir de 769
                    slidesPerView: 3,
                    centeredSlides: true,
                    spaceBetween: 0,
                    direction: 'vertical',
                  }
              },
         
                       
            watchSlidesProgress: true,

              // autoplay: {
              //     delay: 6000,
              //     disableOnInteraction: false
              // },

              pagination: {
                el: pagination_verticale,
                 clickable: true
              },
              navigation: {
                 nextEl: cursor_next,
                 prevEl: cursor_prev
              },

              on: {
                // Empêcher navigation vers les blanks
                slideChange(swiper) {
                    const slide = swiper.slides[swiper.activeIndex];
                    if (slide.classList.contains('is-blank')) {
                        if (swiper.activeIndex < swiper.slides.length / 2) {
                            swiper.slideTo(swiper.activeIndex + 1);
                        } else {
                            swiper.slideTo(swiper.activeIndex - 1);
                        }
                    }
                },
                 click(swiper, event) {
                    if (window.innerWidth <= 767) return;

                    const clickedSlide = swiper.clickedSlide;

                    if (!clickedSlide) return;

                    // Si on clique un slide blank → on ne fait rien
                    if (clickedSlide.classList.contains('is-blank')) {
                        return;
                    }

                    // Sinon → slideToClickedSlide automatiquement
                    swiper.slideTo(swiper.clickedIndex);
                },

                // Scale et opacity
               progress(swiper) {
                swiper.slides.forEach(slide => {
                    const p = slide.progress;

                    if (window.innerWidth <= 767) {
                        return;
                    }

                    // Desktop : scale + opacity
                    let scale = 1 - Math.min(Math.abs(p * 0.3), 0.3);
                    let opacity = 1 - Math.min(Math.abs(p * 0.6), 0.6);

                    slide.style.transform = `scale(${scale})`;
                    slide.style.opacity = opacity;
                });
            },

              setTransition(swiper, speed) {
                    if (window.innerWidth <= 767) return;
                    swiper.slides.forEach(slide => {
                        slide.style.transition = speed + 'ms';
                    });
                },
               //  if (window.innerWidth > 767) return; // mobile uniquement
            }
             
          });

      });



        /***********************************************/   
          /******** SLIDER SWIPER PROJET IMMO ************/
      /***********************************************/
      $( ".SimpleGallery-projectImmo" ).each(function( index ) {
      
          let cursor_next = '#'+$(this).find('.swiper-button-next').attr('id');
          let cursor_prev =  '#'+$(this).find('.swiper-button-prev').attr('id');
          let swiper_id = $(this).find('.slider-sprojectimmo-js').attr('id');
  
          var swiper_gallery_projetcs_immo = new Swiper('#'+swiper_id, {
                spaceBetween: 50, // try '5%' if you want
                slidesPerView: 1,
                loop:true,
                 breakpoints: {
                    768: { // a partir de 769
                      spaceBetween: 20,
                    }
                },

                pagination: {
                  el: '.swiper-bullet-pagination',
                  clickable: true
                },
                navigation: {
                   nextEl: cursor_next,
                   prevEl: cursor_prev
                },
                autoplay: {
                  delay: 6000,
                  disableOnInteraction: false
                },
        });

    });


         $('.btn-trigger-search').on('click', function () {
        $('.btn-quick-menu.btn-search').trigger('click');
    });





/*********************************/
/** TABS SERVICES **/
/*********************************/
    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".BlocTabs .js-Tabs-Inner-Content:not(.tab1)").hide();
    //$(".BlocTabs .js-Tabs-Inner-Content").show();

  /* if in tab mode */
    $(".Tabs-Liste li button").click(function() {

      var activeTab = $(this).attr("aria-controls");
      var parentActiveTab = $(this).parent().parent().parent().attr('data-tabs-id');
     

       if(!$(this).parent().hasClass('active')){

          // $(this).attr('aria-expanded', false);
          // $(this).parent().removeClass('active');
          // $(parentActiveTab+" .js-Tabs-Inner-Content").slideUp();
          // $(parentActiveTab+" .js-Tabs-Inner-Title button").attr('aria-expanded', false);
          // $("#"+activeTab).removeClass('tab_active');   

    
          $(parentActiveTab+" .Tabs-Liste li button").attr('aria-expanded', false);
          $(parentActiveTab+" .Tabs-Liste li").removeClass("active");
          $(parentActiveTab+" .js-Tabs-Inner-Content").hide();


          $(this).attr('aria-expanded', true);
          $("#"+activeTab).fadeIn();     
          $("#"+activeTab).addClass('tab_active');   
          $(this).parent().addClass("active");

          $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
          $(parentActiveTab+" .js-Tabs-Inner-Title[rel^='"+activeTab+"']").addClass("d_active");
          $(parentActiveTab+" .js-Tabs-Inner-Title[rel^='"+activeTab+"'] button").attr('aria-expanded', true);

          let swiper_id_to_active = $(".Tabs-Inner").find('.js-swiper-module-evt');

          $($(".Tabs-Inner").find('.js-swiper-module-evt')).each(function( index ) {
            if ($( this )[0].swiper){
              $( this )[0].swiper.destroy(true, true);
            }
            
            console.log( index);
          });
         

        
        }

         //ScrollTrigger.refresh();
    

    });

/*********************************/
/** TABS EN MODE MOBILE + ACCORDEON SIMPLE, PAR EXEMPLE FOOTER SUR MOBILE **/
/*********************************/


  /* if in drawer mode */
  if(window.innerWidth < 350) {
      $('.BlocTabs .js-Tabs-Inner-Content').hide();
    }
  $(".js-Tabs-Inner-Title button").click(function() {
       var parentActiveTab = $(this).parent().parent().parent().attr('data-tabs-id');
      if($(this).parent().next().css('display') == 'none'){
          $(parentActiveTab+" .js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("aria-controls"); 
          $("#"+d_activeTab).fadeIn();
          $(parentActiveTab+" .Tabs-Liste li button").attr('aria-expanded', false);
        
        $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
        $(parentActiveTab+" .js-Tabs-Inner-Title button").attr('aria-expanded', false);
         $(this).parent().addClass("d_active");
         $(this).attr('aria-expanded', true);
        
        $(parentActiveTab+" .Tabs-Liste li").removeClass("active"); // inutile pour footer mais utile pour global tabs
        $(parentActiveTab+" .Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");  // inutile pour footer mais utile pour global tabs
        $(parentActiveTab+" .Tabs-Liste li[rel^='"+d_activeTab+"'] button").attr('aria-expanded', true);
    }else{
      $(this).attr('aria-expanded', false);
      $(this).parent().next().slideUp(400);
      $(parentActiveTab+" .js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");  // inutile pour footer mais utile pour global tabs
    }
    });
    

    $( "a.scroll_page" ).on( "click", function(e) {
        scroll_to_section($(this).attr('href'));
        e.preventDefault();
    } );

    let topMenuHeight = 0;
    function scroll_to_section(href_dest){
        let variable = 0;
          l_window = $(window).width();
          if(l_window < 1101){
            variable = 0;
          }
       //   
        if($(href_dest).hasClass('SpeAnchor')) variable = 60;

        let offsetTop = href_dest === "#" ? 0 : $(href_dest).offset().top-topMenuHeight+1-variable;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 500);
      }



      if(window.innerWidth < 768) $('.BlocTabs--tabs-fw-767 .js-Tabs-Inner-Content').hide();

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////////////////// Form seach Documents //////////////////////////////////////////////////////////
      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  

      $('.search-form-filter select').niceSelect();
      $('.to_nicedropdown-js').niceSelect();

       ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////////////////// Form seach Documents + FAQ  //////////////////////////////////////////////////////////
      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      /* =========================================================
       ANIMATIONS FADE + SLIDE ULTRA FLUIDES
    ========================================================== */
    const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';

    $.fn.fadeSlideUp = function(duration = 350) {
        return this.each(function(){
            const $el = $(this);
            if (!$el.is(":visible")) return;

            $el.css({
                overflow: 'hidden',
                transition: `all ${duration}ms ${easing}`
            });

            requestAnimationFrame(() => {
                $el.css({
                    height: '0px',
                    opacity: 0,
                    marginTop: 0,
                    marginBottom: 0,
                    paddingTop: 0,
                    paddingBottom: 0
                });
            });

            setTimeout(() => {
                $el.hide().css({
                    height: '',
                    opacity: '',
                    margin: '',
                    padding: '',
                    overflow: '',
                    transition: ''
                });
            }, duration + 20);
        });
    };

    $.fn.fadeSlideDown = function(duration = 350) {
        return this.each(function(){
            const $el = $(this);
            if ($el.is(":visible")) return;

            $el.show();

            const h = $el.height();

            $el.css({
                height: '0px',
                opacity: 0,
                marginTop: '0px',
                marginBottom: '0px',
                overflow: 'hidden',
                transition: `all ${duration}ms ${easing}`
            });

            requestAnimationFrame(() => {
                $el.css({
                    height: h,
                    opacity: 1,
                    marginTop: '',
                    marginBottom: ''
                });
            });

            setTimeout(() => {
                $el.css({
                    height: '',
                    opacity: '',
                    overflow: '',
                    transition: ''
                });
            }, duration + 20);
        });
    };


    /* =========================================================
       FONCTION GÉNÉRIQUE DE FILTRAGE (sans highlight)
    ========================================================== */
    function createFilter(options) {

        const $input    = $(options.input);
        const $sections = $(options.sections);
        const $selects  = options.categorySelect ? $(options.categorySelect) : $();

        const minChars  = options.minChars || 3;

        if (!$input.length || !$sections.length) return;

        function filter() {

            const keywordRaw = $input.val().trim();
            const keyword    = keywordRaw.toLowerCase();

            // Récupère toutes les catégories actives
            const activeCategories = {};
            $selects.each(function(){
                const name = $(this).attr("name") || $(this).data("filter") || "cat";
                activeCategories[name] = $(this).val();
            });

            $sections.each(function(){

                const $section = $(this);
                const $items   = $section.find(options.items);
                let visibleCount = 0;

                $items.each(function(){

                    const $item = $(this);
                    const textContent = $item.find(options.textSelector).text().toLowerCase();

                    // --- FILTRE MOT CLÉ ---
                    const matchKeyword = keywordRaw.length >= minChars ? textContent.includes(keyword) : true;

                    // --- MULTI-FILTRES DE CATÉGORIES ---
                    let matchCategory = true;

                    $selects.each(function(){
                        const selectVal = $(this).val();
                        if (selectVal !== "*") {
                            if (!$item.is(selectVal)) {
                                matchCategory = false;
                            }
                        }
                    });

                    const match = matchKeyword && matchCategory;

                    if (match) {
                        $item.fadeSlideDown(250);
                        visibleCount++;
                    } else {
                        $item.fadeSlideUp(250);
                    }
                });

                if (visibleCount === 0) {
                    $section.fadeSlideUp(300);
                } else {
                    $section.fadeSlideDown(300);
                }
            });
        }

        // --- EVENTS ---

        // Lorsque l’on tape → reset de tous les selects
        $input.on('keyup input', function(){
            $selects.val('*');
            $selects.niceSelect('update');
            filter();
        });

        // Submit du formulaire
        if (options.form) {
            $(options.form).on('submit', function(e){
                e.preventDefault();
                $selects.val('*');
                filter();
            });
        }

        // Gestion des selects
        $selects.on('change', function(){

            // Quand on change un select, on reset l'input et les autres selects
            const changed = this;

            $input.val('');

            $selects.each(function(){
                if (this !== changed) {
                    $(this).val('*');
                    $(this).niceSelect('update'); 
                }
            });

            filter();
        });

        // Premier affichage
        filter();
    }


    /* =========================================================
       UTILISATION SUR TES DEUX PAGES
    ========================================================== */

    // 📄 PAGE DOCUMENTS
    if ($('.pageDoc').length) {
        createFilter({
            input: '.search-form-document .search-field',
            form: '.search-form-document',
            sections: '.mK_doc_download',
            items: '.LinkDownload',
            textSelector: '.LinkDownload-title',
            categorySelect: '.Cpeg-Filter select, .Cpeg-Filter2 select',
            minChars: 3
        });
    }

      // ❓ PAGE FAQ
     if ($('.pageFaq').length) {
    createFilter({
        input: '.bloc_search--docqf .search-field',
        form: '.search-form-document',
        sections: '.mJ_accordeon_faq .s_accordion',
        items: '.acc-item',
        textSelector: '.acc-item-Title, .acc-item-Content',
        categorySelect: '.Cpeg-Filter2 select',
        minChars: 3
    });
  }

      



    /***************************************************************/
    /************** Quick menu rapide sur la droite *********************/
    /***************************************************************/
   

    const quickNav = document.querySelector(".nav_quick_right");
    const headerPage = document.querySelector(".HeaderInfoswArrow");

    if (!quickNav || !headerPage) return;

    const headerHeight = headerPage.offsetHeight;
    const triggerPoint = headerHeight / 2;

    function updateNavState() {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            quickNav.classList.add("compact");
            return;
        }

        if (window.scrollY >= triggerPoint) {
            quickNav.classList.add("compact");
        } else {
            quickNav.classList.remove("compact");
        }
    }

    window.addEventListener("scroll", updateNavState);
    window.addEventListener("resize", updateNavState);

    updateNavState();


 

});